module.exports = __webpack_public_path__ + "static/media/Adolfo.9ced192b.jpg";